import { Link } from "react-router-dom";
import { formatINR } from "@/lib/api";
import { Star } from "lucide-react";

const ratingFor = (id) => {
  let h = 0;
  for (const c of id || "") h = (h * 31 + c.charCodeAt(0)) % 1000;
  const stars = 3.7 + (h % 13) / 10;
  const reviews = 40 + (h % 900);
  return { stars: Math.min(5, Math.round(stars * 10) / 10), reviews };
};

export default function ProductCard({ product }) {
  const finalPrice = Number(product.price) * (1 - Number(product.discount_percent || 0) / 100);
  const hasDiscount = Number(product.discount_percent || 0) > 0;
  const { stars, reviews } = ratingFor(product.id);
  const full = Math.floor(stars);
  const half = stars - full >= 0.5;

  return (
    <Link
      to={`/product/${product.id}`}
      className="group card p-3 flex flex-col hover:shadow-lg transition-shadow"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative aspect-[4/5] bg-[#faf7f2] overflow-hidden rounded-md">
        {product.images?.[0] ? (
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-neutral-400 text-xs">
            No image
          </div>
        )}
        {hasDiscount && (
          <div className="absolute top-3 left-3 deal-tag">-{Math.round(product.discount_percent)}%</div>
        )}
      </div>

      <div className="mt-3 flex-1">
        <div className="text-[10px] uppercase tracking-[0.16em] text-[#6b6b6b]">
          {product.brand || product.category}
        </div>
        <div className="mt-1 text-sm font-medium text-[#1a1d29] line-clamp-2 group-hover:text-[#8b3a3a] transition-colors">
          {product.name}
        </div>

        <div className="mt-1.5 flex items-center gap-1 text-xs text-[#6b6b6b]">
          <div className="flex text-[#d4a017]">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star
                key={i}
                className="w-3.5 h-3.5"
                fill={i < full || (i === full && half) ? "#d4a017" : "transparent"}
                strokeWidth={1.5}
              />
            ))}
          </div>
          <span>({reviews})</span>
        </div>

        <div className="mt-2 flex items-baseline gap-2">
          <span className="font-display text-lg font-semibold text-[#1a1d29]">
            {formatINR(finalPrice)}
          </span>
          {hasDiscount && (
            <span className="text-xs text-[#6b6b6b] line-through">{formatINR(product.price)}</span>
          )}
        </div>

        {product.stock > 0 && product.stock < 10 && (
          <div className="mt-1 text-xs text-[#b52929] font-semibold">Only {product.stock} left</div>
        )}
      </div>
    </Link>
  );
}
